import { render, staticRenderFns } from "./menuAdd.vue?vue&type=template&id=0020444c&scoped=true"
import script from "./menuAdd.vue?vue&type=script&lang=js"
export * from "./menuAdd.vue?vue&type=script&lang=js"
import style0 from "./menuAdd.vue?vue&type=style&index=0&id=0020444c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020444c",
  null
  
)

export default component.exports